export default "__VITE_ASSET__CEIt2922__"